import { ChangeEvent, ReactElement, ReactNode, useState } from "react";
import { Tab, Tabs } from "@mui/material";
import ProductionTable from "./productionTable";
import { useSelector } from "react-redux";
import { ICasterProduction, IParentSize, IState } from "../../../../types";
import ProductionRawTable from "./productionRawTable";

interface IProps {
  productionData: ICasterProduction[];
  parentSize: IParentSize;
}


interface ITabPanelProps {
  children?: ReactNode;
  index: any;
  value: any;
}

const a11yProps = (index: number): any => {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
};

function TabPanel({ children, value, index, ...other }: ITabPanelProps) {

  return (
    <div
      className="flex-grow-1"
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ height: "calc(100% - 48px)" }}>
      {value === index && children}
    </div>
  );
}


const ProductionTabPanel = ({ productionData, parentSize }: IProps): ReactElement => {
  const darkMode = useSelector((state: IState) => state.darkMode);
  const [tabSelected, setTabSelected] = useState(0);

  const handleChange = (_event: ChangeEvent<any>, newValue: number) => {
    setTabSelected(newValue);
  };

  return (
    <div style={{ ...parentSize }}>
      <Tabs
        value={tabSelected}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered={true}
        style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
        <Tab label="Heats" {...a11yProps(0)} />
        <Tab label="Raw Data" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={tabSelected} index={0} >
        <ProductionTable productionData={productionData} parentSize={{ ...parentSize, height: parentSize.height - 50 }} />
      </TabPanel>
      <TabPanel value={tabSelected} index={1} >
        <ProductionRawTable productionData={productionData} parentSize={{ ...parentSize, height: parentSize.height - 50 }} />
      </TabPanel>
    </div>
  );
};

export default ProductionTabPanel;
